export default "__VITE_ASSET__LLpLLEuP__"